import { render } from "./productDetails.vue?vue&type=template&id=5c83fa96"
import script from "./productDetails.vue?vue&type=script&lang=js"
export * from "./productDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__